(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gc-cable-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('addon-quantity-block')) {
    customElements.define(
      'addon-quantity-block',
      class extends HTMLElement {
        connectedCallback() {
          this.onCartUpdate = (event) => {
            const data = event.detail?.data || {};
            // React only to a successful add of this page's product from the product form.
            if (data.source !== 'product-form-component' || data.didError) return;
            if (String(data.productId) !== this.dataset.productId) return;
            const quantity = Number(this.querySelector('select')?.value || 0);
            if (quantity > 0) this.addAddon(quantity);
          };
          document.addEventListener('cart:update', this.onCartUpdate);
          this.querySelector('select')?.addEventListener('change', () => this.showSelection());
          this.showSelection();
        }

        showSelection() {
          const quantity = Number(this.querySelector('select')?.value || 0);
          const summary = this.querySelector('.addon-qty__summary');
          this.classList.toggle('is-selected', quantity > 0);
          if (!summary) return;
          summary.hidden = quantity === 0;
          summary.textContent = quantity === 1
            ? '1 cable will be added with your controller.'
            : quantity + ' cables will be added with your controller.';
        }

        disconnectedCallback() {
          document.removeEventListener('cart:update', this.onCartUpdate);
        }

        async addAddon(quantity) {
          const error = this.querySelector('.addon-qty__error');
          error.hidden = true;
          const sectionIds = [...document.querySelectorAll('cart-items-component')]
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          try {
            const response = await fetch(Theme.routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(this.dataset.addonVariantId), quantity }],
                sections: sectionIds.join(','),
              }),
            });
            const result = await response.json();
            if (result.status) throw new Error(result.description || result.message);
            const cart = await (await fetch('/cart.js')).json();
            // Refresh the cart drawer, cart page and cart bubble like any other cart change.
            const update = new Event('cart:update', { bubbles: true });
            update.detail = {
              resource: cart,
              sourceId: this.id || 'addon-quantity-block',
              data: { source: 'addon-quantity-block', itemCount: cart.item_count, sections: result.sections },
            };
            document.dispatchEvent(update);
          } catch (e) {
            error.textContent = e.message || 'The cable could not be added to your cart.';
            error.hidden = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('notify-me-block')) {
    customElements.define(
      'notify-me-block',
      class extends HTMLElement {
        connectedCallback() {
          // After a signup the page reloads, possibly on an in-stock variant; still show the confirmation.
          if (this.querySelector('.notify-me__success, .notify-me__error')) this.hidden = false;
          this.onVariantUpdate = (event) => {
            const { resource, data } = event.detail || {};
            if (!resource || (data && data.productId && data.productId !== this.dataset.productId)) return;
            // Keep the confirmation visible after a successful signup.
            if (this.querySelector('.notify-me__success')) return;
            this.hidden = resource.available !== false;
            // Tag the exact variant so the restock workflow only emails people waiting for it.
            const tags = this.querySelector('input[name="contact[tags]"]');
            if (tags && resource.id) {
              tags.value = `${tags.dataset.tagBase}, notify-v-${resource.id}${this.partTags()[resource.id] || ''}`;
            }
          };
          document.addEventListener('variant:update', this.onVariantUpdate);
        }
        partTags() {
          if (!this._partTags) {
            try {
              this._partTags = JSON.parse(this.querySelector('[data-part-tags]')?.textContent || '{}');
            } catch {
              this._partTags = {};
            }
          }
          return this._partTags;
        }
        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariantUpdate);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
